(() => {
  'use strict';
  const labels = JSON.parse(document.getElementById('rok-results-labels')?.textContent || '{}');
  const cache = new Map();
  const states = new WeakMap();
  const buttonLabels = new WeakMap();
  const queue = [];
  let active = 0;
  const pump = () => {
    while (active < 4 && queue.length) {
      const task = queue.shift();
      active++;
      task().finally(() => { active--; pump(); });
    }
  };
  const read = (url) => {
    const request = new URL(url.pathname, location.origin);
    const variant = url.searchParams.get('variant');
    if (variant) request.searchParams.set('variant', variant);
    request.searchParams.set('section_id', 'rok-result-info');
    const key = request.href;
    if (!cache.has(key)) {
      cache.set(key, new Promise((resolve, reject) => {
        queue.push(async () => {
          try {
            const response = await fetch(key, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
            if (!response.ok) throw new Error('Product information unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = html.querySelector('[data-rok-result-info]');
            if (!data) throw new Error('Product information unavailable');
            resolve(JSON.parse(data.textContent));
          } catch (error) { reject(error); }
        });
        pump();
      }));
      if (cache.size > 250) cache.delete(cache.keys().next().value);
    }
    return cache.get(key);
  };
  const keyFor = link => {
    const url = new URL(link.href, location.href);
    return url.pathname + '|' + (url.searchParams.get('variant') || '');
  };
  const apply = (link) => {
    const card = link.closest('.snize-product');
    if (!card) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
    const key = keyFor(link);
    if (states.get(card) === key) return;
    states.set(card, key);
    delete card.dataset.rokInfoLoaded;
    const action = card.querySelector('.snize-add-to-cart-button');
    if (action && buttonLabels.has(action)) action.textContent = buttonLabels.get(action);
    card.querySelector('.rok-result-sku')?.remove();
    card.querySelector('.rok-result-from')?.remove();
    card.querySelector('.rok-result-pro-badge')?.remove();
    card.removeAttribute('data-rok-choose-options');
    read(url).then(data => {
      if (!card.isConnected || states.get(card) !== key || keyFor(link) !== key) return;
      if (String(data.id) !== card.dataset.originalProductId) return;
      card.dataset.rokInfoLoaded = 'true';
      const title = card.querySelector('.snize-title');
      if (!title) return;
      const skus = [...new Set((data.skus || []).filter(s => s && s.trim()))];
      let text = data.sku ? labels.sku + ': ' + data.sku : '';
      if (!data.selected && data.count > 1) {
        text = (skus.length ? labels.skus + ': ' + skus.join(', ') + (data.count > 3 ? '…' : '') + ' · ' : '') + data.count + ' ' + labels.options;
      }
      if (text) {
        const sku = document.createElement('span');
        sku.className = 'rok-result-sku';
        sku.textContent = text;
        title.after(sku);
      }
      if (data.proPrice) {
        const price = card.querySelector('.snize-price');
        if (price) {
          price.textContent = data.proPrice;
}
      }
      if (!data.selected && (data.proPrice ? data.proVaries : data.priceVaries)) {
        const price = card.querySelector('.snize-price');
        if (price && !price.textContent.trim().startsWith(labels.from)) {
          const from = document.createElement('span');
          from.className = 'rok-result-from';
          from.textContent = labels.from + ' ';
          price.prepend(from);
        }
      }
      if (!data.selected && data.count > 1) {
        const button = card.querySelector('.snize-add-to-cart-button');
        if (button) {
          if (!buttonLabels.has(button)) buttonLabels.set(button, button.textContent);
          button.textContent = labels.chooseOptions;
          card.dataset.rokChooseOptions = 'true';
        }
      }
    }).catch(() => {});
  };
  let pending = false;
  const refresh = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      document.querySelectorAll('.snize-product a.snize-view-link').forEach(apply);
      document.querySelectorAll('.snize-main-panel-dropdown-button > span').forEach(span => {
        if (!span.textContent.trim()) span.textContent = labels.sort;
      });
    });
  };
  document.addEventListener('click', event => {
    const sortButton = event.target.closest?.('.snize-main-panel-dropdown.dedicated .snize-main-panel-dropdown-button');
    if (sortButton) {
      const menu = sortButton.parentElement.querySelector('.snize-main-panel-dropdown-content');
      if (menu) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const open = sortButton.getAttribute('aria-expanded') !== 'true';
        sortButton.setAttribute('aria-expanded', String(open));
        menu.style.display = open ? 'block' : 'none';
      }
      return;
    }
    const button = event.target.closest?.('[data-rok-choose-options] .snize-add-to-cart-button');
    if (!button) return;
    const link = button.closest('a.snize-view-link');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(link.href);
  }, true);
  const closeSort = () => document.querySelectorAll('.snize-main-panel-dropdown.dedicated').forEach(dropdown => {
    dropdown.querySelector('.snize-main-panel-dropdown-button')?.setAttribute('aria-expanded', 'false');
    const menu = dropdown.querySelector('.snize-main-panel-dropdown-content');
    if (menu) menu.style.display = 'none';
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeSort(); });
  document.addEventListener('click', event => { if (!event.target.closest?.('.snize-main-panel-dropdown.dedicated')) closeSort(); });
  const start = () => {
    refresh();
    new MutationObserver(refresh).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['href', 'data-original-product-id'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

